import { render, staticRenderFns } from "./FindSurrogateId.vue?vue&type=template&id=332d65c6&scoped=true&"
import script from "./FindSurrogateId.vue?vue&type=script&lang=js&"
export * from "./FindSurrogateId.vue?vue&type=script&lang=js&"
import style0 from "./FindSurrogateId.vue?vue&type=style&index=0&id=332d65c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332d65c6",
  null
  
)

export default component.exports